module.exports = __webpack_public_path__ + "img/dateRange.fda7bb19.svg";